import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../Store/context';
import img1 from '../Images/icons/complaint1.svg'
import img2 from '../Images/icons/complaint2.svg'
import img3 from '../Images/icons/complaint3.svg'
import img4 from '../Images/icons/complaint4.svg'
import img5 from '../Images/icons/complaint5.svg'
import img6 from '../Images/icons/complaint6.svg'

import img11 from '../Images/icons/complaint1.png'
import img22 from '../Images/icons/complaint2.png'
import img33 from '../Images/icons/complaint3.png'
import img44 from '../Images/icons/complaint4.png'
import img55 from '../Images/icons/complaint5.png'
import img66 from '../Images/icons/complaint6.png'
import { Link } from 'react-router-dom';
import { GetCourtcomplains } from '../api/Queries/get';
import Loading from './loader/loader';

const ComplaintCards = () => {
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const { showError, darkMode } = useContext(Context);
    const [data, setData] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        const getComplains = async () => {
            try {
                const response = await GetCourtcomplains();
                setData(response);
                setIsLoading(false);
            } catch (error) {
                showError(error.message);
                setIsLoading(false);
            }
        };
        getComplains();
    }, [showError]);

    const getCategory = (c) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
          return c.name_rus;
        } else if (currentLang === 'en') {
          return c.name_eng;
        }
        return c.name_tm;
      };
      

      const icons = darkMode
      ? [img11, img22, img33, img44, img55, img66] 
      : [img1, img2, img3, img4, img5, img6];

    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4'>
            {isLoading ? <Loading /> : <>
                {data?.map((item, i) => (
                    <div
                        key={i}
                        className='bg-white dark:bg-dark-border shadow h-max min-h-[200px] w-full
                                    rounded-xl hover:shadow-xl p-4 xl:p-8 transition-transform
                                    duration-500 ease-out hover:scale-[1.04] relative'
                    >
                    <Link to={`/complaint-board/${item.id}`}>
                            <img
                              src={icons[i % icons.length]}
                                alt="undefined"
                                className='h-12 md:h-10 object-contain mx-auto'
                            />
                            <p className='flex h-[100px] my-2 items-center 
                                          text-center justify-center'>
                                {getCategory(item)}
                            </p>

                            <p className='absolute bottom-4 left-4 text-primary 
                                          dark:text-dark-text font-medium mt-2'>
                                {t('full')}
                            </p>
                        </Link>
                    </div>

                ))} 
                </>
            }
            </div>
        </div>
    );
};

export default ComplaintCards;

